"use client"

import Link from "next/link";
import { useParams } from "next/navigation";
import { CloudIcon } from "@heroicons/react/24/solid";
import { UseStatusResponse, useStatus } from "./dpswr";
import { Tooltip, TooltipContent, TooltipTrigger } from "@heroui/react";
import { t } from "@lingui/core/macro";

export default function DonorPortalStatusIcon () {

    const statusResponse: UseStatusResponse = useStatus();
    const params = useParams();
    const lang = (params?.lang as string) ?? 'en';
    const href = `/${lang}/status`;

    if ( statusResponse.isLoading ) {
        return(
            <Link href={href}>
                <CloudIcon className="h-4 w-4 fill-white" />
            </Link>
        );
    }

    if ( statusResponse.errorObject ) {
        return(
            <Tooltip>
                <TooltipTrigger><Link href={href}><div><CloudIcon className="h-4 w-4 fill-kexp-light-danger-600" /></div></Link></TooltipTrigger>
                <TooltipContent showArrow={true}>{t`Connectivity issues. Please stay tuned.`}</TooltipContent>
            </Tooltip>
        );
    }

    if ( ( statusResponse.serviceInfo?.status == "MINOR_ISSUES" ) ||
         ( statusResponse.serviceInfo?.status == "SCHEDULED_MAINTENANCE" ) ) {
        return(
            <Tooltip>
                <TooltipTrigger><Link href={href}><div><CloudIcon className="h-4 w-4 fill-kexp-light-warning-600" /></div></Link></TooltipTrigger>
                <TooltipContent showArrow={true}>{t`Minor issues. Updates in progress.`}</TooltipContent>
            </Tooltip>
        );
    }
    else if ( statusResponse.serviceInfo?.status === "SEVERE_ISSUES" ) {
        return(
            <Tooltip>
                <TooltipTrigger><Link href={href}><div><CloudIcon className="h-4 w-4 fill-kexp-light-danger-600" /></div></Link></TooltipTrigger>
                <TooltipContent showArrow={true}>{t`Processing issues being addressed. Please stay tuned.`}</TooltipContent>
            </Tooltip>
        );
    }

    return(
        <Tooltip>
            <TooltipTrigger><Link href={href}><CloudIcon className="h-4 w-4 fill-kexp-light-success-500" /></Link></TooltipTrigger>
            <TooltipContent showArrow={true} placement="top end">{t`Where the music matters`}</TooltipContent>
        </Tooltip>
    );
}